import axios from "axios";
import { toast } from "react-toastify";

const removeToken = () => {
  localStorage.removeItem("access_token");
  toast.error("Unauthorized User!");
  window.location.reload();
};

export const apiInstance = axios.create({
  baseURL: process.env.REACT_APP_API_KEY,
  headers: {},
});

apiInstance.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
apiInstance.interceptors.response.use(
  function (response) {
    const { meta, ...rest } = response?.data;
    if (!meta.status) {
      toast.error(meta.message);
    };
    const data = { ok: meta?.status, ...rest }
    return data;
  },
  function (error) {
    const { data, status } = error?.response;
    if (status == 401 && data?.Message == "Token expired") {
      removeToken();
    }
    console.log(error);
  }
);


